export default (props, vars) => props?.['mode'] === 'accepted';
